import * as Yup from 'yup';
import i18n from 'i18next';

const text_required = i18n.t('testing.validation.required');
const text_number = i18n.t('testing.validation.number');
const text_email = i18n.t('testing.validation.email');
const text_url = i18n.t('testing.validation.url');
const text_select = i18n.t('testing.validation.select');

export const useCustomFieldsExtendValidation = (customFields) => {

    return customFields.map((customField) => {
        const commonValidations = [
            ...(customField.validate?.required ? [{ type: "required", params: [text_required] }] : []),
        ];

        switch (customField.type) {
            case "number":
                return {
                    ...customField,
                    validationType: "number",
                    validations: [
                        {
                            type: "typeError",
                            params: [text_number]
                        },
                        ...commonValidations,
                        ...(customField.validate?.min !== undefined ? [{
                            type: "min",
                            params: [Number(customField.validate.min), i18n.t('testing.validation.min', { min: customField.validate.min })]
                        }] : []),

                        ...(customField.validate?.max !== undefined ? [{
                            type: "max",
                            params: [Number(customField.validate.max), i18n.t('testing.validation.max', { max: customField.validate.max })]
                        }] : []),
                    ]
                };
            case "text":
                return {
                    ...customField,
                    validationType: "string",
                    validations: [
                        ...commonValidations,
                        ...(customField.validate?.minLength !== undefined ? [{
                            type: "minLength",
                            params: [
                                customField.validate.minLength,
                                i18n.t('testing.validation.minLength', { minLength: customField.validate.minLength })
                            ]
                        }] : []),
                        ...(customField.validate?.maxLength !== undefined ? [{
                            type: "maxLength",
                            params: [
                                customField.validate.maxLength,
                                i18n.t('testing.validation.maxLength', { maxLength: customField.validate.maxLength })
                            ]
                        }] : []),
                    ]
                };
            case "radio":
                return {
                    ...customField,
                    validationType: "radio",
                    validations: [
                        ...commonValidations,
                    ]
                }

            case "select":
                return {
                    ...customField,
                    validationType: "mixed",
                    validations: [
                        {
                            type: "notOneOf",
                            params: [[null, ''], text_select],
                        },
                        ...commonValidations,
                    ]
                };
            case "email":
                return {
                    ...customField,
                    validationType: "string",
                    validations: [
                        ...commonValidations,
                        {
                            type: "email",
                            params: [text_email]
                        }
                    ]
                };
            case "url":
                return {
                    ...customField,
                    validationType: "string",
                    validations: [
                        ...commonValidations,
                        {
                            type: "url",
                            params: [text_url]
                        }
                    ]
                };
            default:
                return customField;
        }
    });
};


// This function creates the dynamic Yup schema
export const useCustomFieldsDynamicSchema = (schema, config) => {
    const { name, validationType, validations = [] } = config;
    if (!Yup[validationType]) {
        return schema;
    }
    let validator = Yup[validationType]();
    validations.forEach((validation) => {
        const { params, type } = validation;
        if (!validator[type]) {
            return;
        }
        validator = validator[type](...params);
    });
    schema[name] = validator;
    return schema;
};

